import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import KasaBilgisi from "@/pages/KasaBilgisi";
import SahaRaporu from "@/pages/SahaRaporu";
import SahaEkipleri from "@/pages/SahaEkipleri";
import SahaHesaplari from "@/pages/SahaHesaplari";
import HavaleFast from "@/pages/HavaleFast";
import KullaniciAyarlari from "@/pages/KullaniciAyarlari";
import HazirCevaplar from "@/pages/HazirCevaplar";
import Kullanicilar from "@/pages/Kullanicilar";
import BayiYonetimi from "@/pages/BayiYonetimi";
import Bonuslar from "@/pages/Bonuslar";
import Bildirimler from "@/pages/Bildirimler";
import Yetkiler from "@/pages/Yetkiler";
import Loglar from "@/pages/Loglar";
import SiteAyarlari from "@/pages/SiteAyarlari";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/kullanicilar" element={<Kullanicilar />} />
          <Route path="/bayi-yonetimi" element={<BayiYonetimi />} />
          <Route path="/kasa-bilgisi" element={<KasaBilgisi />} />
          <Route path="/saha-raporu" element={<SahaRaporu />} />
          <Route path="/saha-ekipleri" element={<SahaEkipleri />} />
          <Route path="/saha-hesaplari" element={<SahaHesaplari />} />
          <Route path="/havale-fast" element={<HavaleFast />} />
          <Route path="/bonuslar" element={<Bonuslar />} />
          <Route path="/bildirimler" element={<Bildirimler />} />
          <Route path="/yetkiler" element={<Yetkiler />} />
          <Route path="/loglar" element={<Loglar />} />
          <Route path="/kullanici-ayarlari" element={<KullaniciAyarlari />} />
          <Route path="/site-ayarlari" element={<SiteAyarlari />} />
          <Route path="/hazir-cevaplar" element={<HazirCevaplar />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
